"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PdfPreview = exports.PdfLink = exports.Preview = exports.Name = exports.FileIconWrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const ReactPdf_1 = require("@src/components/modules/global/ReactPdf");
const icons_1 = require("@ant-design/icons");
const react_intl_1 = require("react-intl");
const styled_components_1 = __importDefault(require("styled-components"));
exports.FileIconWrapper = styled_components_1.default.div `
	display: flex;
	justify-content: center;
	align-items: center;

	svg {
		color: ${({ theme }) => theme.color.gray3};
		height: 60px;
		width: 60px;
	}
`;
exports.Name = styled_components_1.default.div `
	font-size: 0.8rem;
	text-overflow: ellipsis;
	display: block;
	overflow: hidden;
	white-space: nowrap;
	width: 6.5rem;
`;
exports.Preview = styled_components_1.default.div `
	flex: 1;
	width: calc(100% - 11px);
	height: 100%;
	position: absolute;
	transition: ${({ theme }) => theme.transition.basic};
	display: flex;
	flex-direction: column;
	justify-content: space-around;
`;
exports.PdfLink = styled_components_1.default.a `
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	z-index: 1;
`;
const PdfPreviewWrapper = styled_components_1.default.div `
	width: 7rem;
	min-height: 10.5rem;
	border: 2px solid ${({ theme }) => theme.color.gray3};
	cursor: pointer;
	padding: 0.3rem;
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	border-radius: ${({ theme }) => theme.borderRadius.base};
	background: ${({ theme }) => theme.color.background};

	canvas {
		max-width: 100%;
		height: auto !important;
	}

	.react-pdf__Page__textContent {
		display: none;
	}

	.react-pdf__Page__canvas {
		border-radius: ${({ theme }) => theme.borderRadius.base};
	}

	a {
		opacity: 0;

		svg {
			width: 2.5rem;
			height: 2.5rem;
		}
	}

	&:hover {
		a {
			opacity: 1;
		}

		${exports.Preview} {
			opacity: 0;
		}
	}
`;
const PdfPreview = (props) => {
    const { documentUrl, documentName } = props;
    return ((0, jsx_runtime_1.jsxs)(PdfPreviewWrapper, { children: [(0, jsx_runtime_1.jsxs)(exports.Preview, { children: [(0, jsx_runtime_1.jsx)(ReactPdf_1.Document, { file: documentUrl, error: (0, jsx_runtime_1.jsx)(exports.FileIconWrapper, { children: (0, jsx_runtime_1.jsx)(icons_1.FileTextOutlined, {}) }), loading: (0, jsx_runtime_1.jsx)(exports.FileIconWrapper, { children: (0, jsx_runtime_1.jsx)(icons_1.FileTextOutlined, {}) }), children: (0, jsx_runtime_1.jsx)(ReactPdf_1.Page, { pageNumber: 1 }) }), (0, jsx_runtime_1.jsx)(exports.Name, { children: documentName })] }), (0, jsx_runtime_1.jsxs)(exports.PdfLink, { href: documentUrl, title: documentName, rel: "noopener noreferrer", target: "_blank", children: [(0, jsx_runtime_1.jsx)("div", { className: "flex-center", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "global.pdf_preview.download", defaultMessage: "Stiahnu\u0165" }) }), (0, jsx_runtime_1.jsx)(icons_1.DownloadOutlined, {})] })] }));
};
exports.PdfPreview = PdfPreview;
